import Vue from "vue";

import Token from "./Token.vue";

export function load(payload) {
  const selector = "token";
  let store = payload;

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return; // go no further
  }

  // Create a new Vue app with the imported component
  new Vue({
    store,
    render: createElement =>
      createElement(Token, {
        props: {
          ...window[selector]
        }
      }),
  }).$mount(selector);
}